<div *ngIf="valid">
    Hello
</div>